function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:#fff;}.cls-2{fill-rule:evenodd;}"));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M62.604,62.558c0,2.883-2.337,5.22-5.22,5.22s-5.22-2.337-5.22-5.22,2.337-5.22,5.22-5.22,5.22,2.337,5.22,5.22Z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M32.69,35.615c-9.806,0-17.785-7.978-17.785-17.785S22.884.045,32.69.045s17.786,7.978,17.786,17.785-7.979,17.785-17.786,17.785ZM32.69,4.832c-7.168,0-12.999,5.831-12.999,12.998s5.831,12.999,12.999,12.999,12.998-5.831,12.998-12.999-5.831-12.998-12.998-12.998Z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M57.084,67.988c-3.208,0-5.819-2.61-5.819-5.818s2.61-5.819,5.819-5.819,5.819,2.61,5.819,5.819-2.61,5.818-5.819,5.818Z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M46.823,79.955c-6.977,0-12.654-5.677-12.654-12.654v-10.261c0-5.356,3.39-10.152,8.436-11.935l1.825-.645v-3.072c0-6.977,5.677-12.654,12.654-12.654s12.655,5.677,12.655,12.654v3.072l1.825.645c5.046,1.783,8.436,6.579,8.436,11.935v10.261c0,6.978-5.677,12.654-12.655,12.654h-20.522ZM46.823,49.171c-4.338,0-7.867,3.53-7.867,7.868v10.261c0,4.338,3.529,7.868,7.867,7.868h20.522c4.339,0,7.868-3.53,7.868-7.868v-10.261c0-4.338-3.53-7.868-7.868-7.868h-20.522ZM64.952,44.385v-2.998c0-4.338-3.53-7.868-7.869-7.868s-7.867,3.53-7.867,7.868v2.998h15.736Z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M12.654,79.955C5.677,79.955,0,74.278,0,67.3v-5.131C0,49.534,10.28,39.254,22.916,39.254h13.183c.889,0,1.696.49,2.107,1.278.409.785.347,1.723-.16,2.448-.473.677-1.201,1.061-1.971,1.061h-13.158c-9.996,0-18.129,8.133-18.129,18.129v5.131c0,4.338,3.53,7.868,7.868,7.868h20.432c.924,0,1.749.528,2.153,1.377.364.764.312,1.61-.121,2.297-.44.696-1.193,1.112-2.015,1.112H12.654Z"
});

var SvgNavUser01 = function SvgNavUser01(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    viewBox: "0 0 80 80",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNavUser01, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/nav_user01.36055fcf.svg";
export { ForwardRef as ReactComponent };